import React from "react";
import { Box, Typography, Avatar, Grid, Chip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { useTranslation } from "react-i18next";
// Images of board members
import haraImg from "images/people/hara.jpg";
import anbeImg from "images/people/anbe.png";
import BgTitle from "components/title/BgTitle";

export default () => {
  const { t } = useTranslation();
  const images = [
    haraImg,
    anbeImg,
    "", // 岡村 貴史 - no photo
    "", // 平野 健太郎 - no photo
  ];

  const boardMembers = t("board_members", { returnObjects: true })
    .map((member, index) => ({ ...member, image: images[index] }))
    .filter((member) => !member.hidden);

  return (
    <Box sx={{ py: 4 }}>
      {/* Header Section */}
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <BgTitle isCenter={true} text={t("board_member_heading")} />
        <Box
          sx={{
            borderLeft: "4px solid",
            borderColor: "primary.main",
            p: 1,
            mt: 2,
            bgcolor: "#f5f5f5",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              mx: "auto",
              lineHeight: 1.6,
              fontSize: "0.8rem",
              textAlign: "left",
            }}
          >
            {t("board_member_description")}
          </Typography>
        </Box>
      </Box>

      {/* Members Grid */}
      <Grid container spacing={2}>
        {boardMembers.map((member, index) => (
          <Grid item xs={6} sm={4} key={index}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                p: 2,
                borderRadius: 2,
                transition: "transform 0.2s",
                "&:active": {
                  transform: "scale(0.98)",
                },
              }}
            >
              {/* Member Image */}
              <Avatar
                src={member.image}
                sx={{
                  width: { xs: 120 },
                  height: { xs: 120 },
                  mb: 2,
                  bgcolor: "#bdbdbd40",
                  border: "4px solid",
                  borderColor: "background.paper",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
                }}
              >
                {!member.image && (
                  <PersonIcon
                    sx={{
                      fontSize: "2.5rem",
                      color: "black",
                    }}
                  />
                )}
              </Avatar>

              {/* Position Tag */}
              <Chip
                label={member.position}
                size="small"
                sx={{
                  mb: 1,
                  bgcolor: "primary.lighter",
                  color: "black",
                  fontWeight: 750,
                  fontSize: "0.75rem",
                }}
              />

              {/* Name */}
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 500,
                  textAlign: "center",
                  color: "text.primary",
                  mt: 1,
                  fontSize: "0.75rem",
                }}
              >
                {member.name}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
